import clsx from "clsx";
import styles from "./index.module.css";

type TimeLeftToPurchaseProps = {
  // Should be an ISO datetime string in the future, e.g. "2021-09-01T00:00:00.000Z"
  // that we format to: "5 hours left"
  purchaseExpirationDate: string;
};

function formatTimeLeft(time: string) {
  // TODO:
  return time && "5 hours left";
}

export function TimeLeftToPurchase(props: TimeLeftToPurchaseProps) {
  return (
    <div
      className={clsx(
        styles.timeLeftToPurchase,
        "px-xxs z-2 bg-gray-950 absolute top-0 left-0 border-r border-b bg-opacity-30 text-xs uppercase backdrop-blur-sm",
      )}
    >
      {formatTimeLeft(props.purchaseExpirationDate)}
    </div>
  );
}
